import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { AuthLayout } from '../components/auth/AuthLayout';
import { Banner, Spinner } from '../components/ui';

const MagicLinkPage: React.FC = () => {
  const { loadUser } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const magicToken = searchParams.get('token');

    if (!magicToken) {
      setError('Kein Token gefunden.');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    const exchangeToken = async () => {
      try {
        // Send magic token to exchange for session cookies
        await axios.post(`/user/refresh`, {
          token: magicToken
        }, {
          withCredentials: true
        });

        // Clear legacy storage just in case
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');

        // Redirect to dashboard - AuthContext will pick up cookies automatically
        await loadUser();
        navigate('/dashboard', { replace: true });
      } catch (err: any) {
        console.error('Magic link exchange error:', err);
        setError(err.response?.data?.error || 'Fehler beim Login. Der Link ist möglicherweise abgelaufen.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    exchangeToken();
  }, [searchParams, navigate, loadUser]);

  if (error) {
    return (
      <AuthLayout title="Anmeldung per Link">
        <Banner tone="danger" title="Fehler">
          <p>{error}</p>
          <p className="mt-1">Du wirst zum Login weitergeleitet…</p>
        </Banner>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Anmeldung per Link">
      <div className="flex flex-col items-center gap-3 py-4 text-center">
        <Spinner size={28} />
        <p className="text-muted">Bitte warte, du wirst eingeloggt.</p>
      </div>
    </AuthLayout>
  );
};

export default MagicLinkPage;
